import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import UnifiedNavigation from '../../components/Navigation/UnifiedNavigation';
import PropertyHeroSection from '../../components/PropertyHeroSection/PropertyHeroSection';
import AtacamaVideoSection from '../../components/AtacamaVideoSection/AtacamaVideoSection';
import PremiumCarouselAtacama from '../../components/PremiumCarousel/PremiumCarouselAtacama';
import AtacamaExperiencesSection from '../../components/AtacamaExperiencesSection/AtacamaExperiencesSection';
import AtacamaOffersSection from '../../components/AtacamaOffersSection/AtacamaOffersSection';
import AtacamaMapSection from '../../components/AtacamaMapSection/AtacamaMapSection';
import AtacamaBlogSection from '../../components/AtacamaBlogSection/AtacamaBlogSection';
import InstagramSection from '../../components/BrandHomePage/InstagramSection';
import Footer from '../../components/Footer/Footer';
import { images } from '../../components/shared/assets';
import { useOverlayManager } from '../../contexts/OverlayContext';
import { initializeAllFeatures } from '../../utils/interactiveFeatures';
import '../../styles/property-pages.css';
import './AtacamaPage.css';


const AtacamaPageHardcoded: React.FC = () => {
  const { setHoveredDestination } = useOverlayManager();
  const { t } = useTranslation();

  // Initialize all interactive features
  useEffect(() => {
    const cleanup = initializeAllFeatures();
    // Clear any lingering hover state to ensure correct footer variant
    setHoveredDestination(null);
    return cleanup;
  }, []);

  return (
    <div className="property-page property-page--atacama">
      {/* Navigation - Transparent variant for hero section */}
      <UnifiedNavigation variant="transparent" destination="atacama" />
      
      {/* Hero Section */}
      <div className="hero-section-wrapper">
        <PropertyHeroSection 
          propertySlug="atacama"
          customContent={{
            title: t('properties/atacama:hero.title'),
            copy: '' // Explicitly disable description text
          }}
        />
      </div>

      {/* Content Sections with Scroll Reveals */}
      <div className="content-wrapper">
        
        {/* Premium Carousel - The horizontal carousel we fixed */}
        <div data-scroll-section="carousel" className="scroll-reveal-section">
          <PremiumCarouselAtacama />
        </div>


        {/* Full Viewport Video Section */}
        <AtacamaVideoSection />

        {/* Experience Your Own Path Private Excursions Section */}
        <div data-scroll-section="experiences" className="scroll-reveal-section">
          <AtacamaExperiencesSection />
        </div>

        {/* Offers Section */}
        <div data-scroll-section="offers" className="scroll-reveal-section">
          <AtacamaOffersSection />
        </div>

        {/* Map Section */}
        <div data-scroll-section="map" className="scroll-reveal-section">
          <AtacamaMapSection />
        </div>

        {/* Blog Section */}
        <div data-scroll-section="blog" className="scroll-reveal-section">
          <AtacamaBlogSection />
        </div>

        {/* Instagram Section */}
        <InstagramSection />

        {/* Footer */}
        <Footer variant="atacama" />
      </div>
    </div>
  );
};

export default AtacamaPageHardcoded;